// @ts-check

/** @file Defines the local ReplicaMetadata shell. */

import ReplicaMetadataBase from "../model-bases/replica-metadata.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"

/** Durable local-replica metadata row, separate from installation Options. */
const ReplicaMetadataModel = projectReplicaModel(ReplicaMetadataBase)

export default ReplicaMetadataModel

ReplicaMetadataModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
ReplicaMetadataModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
